import { render, staticRenderFns } from "./jackpot.vue?vue&type=template&id=07aa035a&scoped=true"
import script from "./jackpot.vue?vue&type=script&lang=js"
export * from "./jackpot.vue?vue&type=script&lang=js"
import style0 from "./jackpot.vue?vue&type=style&index=0&id=07aa035a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07aa035a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07aa035a')) {
      api.createRecord('07aa035a', component.options)
    } else {
      api.reload('07aa035a', component.options)
    }
    module.hot.accept("./jackpot.vue?vue&type=template&id=07aa035a&scoped=true", function () {
      api.rerender('07aa035a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/popup/jackpot.vue"
export default component.exports